import { render, staticRenderFns } from "./forGoods.vue?vue&type=template&id=17051301&scoped=true&"
import script from "./forGoods.vue?vue&type=script&lang=js&"
export * from "./forGoods.vue?vue&type=script&lang=js&"
import style0 from "./forGoods.vue?vue&type=style&index=0&id=17051301&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17051301",
  null
  
)

export default component.exports